import miniToastr from 'mini-toastr'

miniToastr.init({ allowHtml: true })

export default miniToastr
